import { FC, useEffect } from 'react';
import scrollTopIcon from 'assets/icons/scroll-top-light.svg';
import { useSchedule } from 'features/index';
import { useAppSelector } from 'shared/lib';

import { ContainerSchedule } from '../containerSchedule';
import { useScroll } from '../hooks';
import { makeTables, makeTablesWithoutDate } from '../lib';
import { SkeletonSchedule } from '../skeletonSchedule';
import { TableSwitchSchedule } from '../tableSwitchSchedule';

import styles from './styles.module.scss';

export const StageTableSchedule: FC = () => {
  const { startIntervalDate, isGroupSchedule, endIntervalDate } =
    useAppSelector((state) => state.schedulePublicReducer);
  const { tableViewScheduleStage } = useAppSelector(
    (state) => state.viewStageReducer,
  );

  const {
    groupSchedule,
    groupScheduleWithoutDate,
    isSkeleton,
    teacherSchedule,
    teacherScheduleWithoutDate,
    filterSchedule,
  } = useSchedule();

  useEffect(() => {
    filterSchedule(startIntervalDate, endIntervalDate);
  }, [startIntervalDate, endIntervalDate]);

  const {
    containerScheduleRef,
    handleMouseDown,
    handleMouseLeave,
    handleMouseMove,
    handleMouseUp,
    handleScroll,
    isDragging,
    isScrollToTopVisible,
    scrollToTop,
  } = useScroll();

  return (
    <div
      className={styles['stage-table-schedule']}
      style={{ cursor: isDragging ? 'grabbing' : 'default' }}
      ref={containerScheduleRef}
      onScroll={handleScroll}
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeave}
      onMouseUp={handleMouseUp}
      onMouseMove={handleMouseMove}
    >
      <ContainerSchedule>
        <TableSwitchSchedule />
        {isSkeleton ? (
          <SkeletonSchedule />
        ) : tableViewScheduleStage === 'byDay' ? (
          makeTables(
            isGroupSchedule,
            isGroupSchedule ? groupSchedule : teacherSchedule,
            startIntervalDate,
            endIntervalDate,
          )
        ) : (
          makeTablesWithoutDate(
            isGroupSchedule,
            isGroupSchedule
              ? groupScheduleWithoutDate
              : teacherScheduleWithoutDate,
          )
        )}
      </ContainerSchedule>
      {isScrollToTopVisible && (
        <button className={styles['scroll-top-button']} onClick={scrollToTop}>
          <img
            className={styles['scroll-top-button__icon']}
            src={scrollTopIcon}
          />
        </button>
      )}
    </div>
  );
};
